export default "__VITE_ASSET__BSuYlnUo__"